<script>
import { mapActions } from 'vuex';

export default {
  name: 'Itinerary',
  methods: {
    ...mapActions({
      clearState: 'itinerary/clearState',
    }),
  },
  destroyed() {
    this.clearState();
  },
};
</script>
<template>
  <router-view></router-view>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/Itinerary.vue